import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
export default function setRowsFlagStateHelper(itemRowKeys, tableViewId, flagStatusToApply, setRowsFlagStateInternal) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    // Filter out the rows which has the same flag type as the new flag type
    var filteredRowKeys = itemRowKeys.filter(function (rowKey) { return MailRowDataPropertyGetter.getFlagStatus(rowKey, tableView) != flagStatusToApply; });
    if (filteredRowKeys.length == 0) {
        // Nothing to set flag status on
        return;
    }
    setRowsFlagStateInternal(filteredRowKeys, flagStatusToApply);
}
//# sourceMappingURL=setRowsFlagStateHelper.js.map